var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoFacebookFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.885 19.8922C38.885 9.40765 30.3758 0.898438 19.8912 0.898438C9.40667 0.898438 0.897461 9.40765 0.897461 19.8922C0.897461 29.0852 7.43132 36.7397 16.0925 38.5061V25.5903H12.2937V19.8922H16.0925V15.1438C16.0925 11.478 19.0745 8.49595 22.7403 8.49595H27.4887V14.1941H23.69C22.6453 14.1941 21.7906 15.0488 21.7906 16.0935V19.8922H27.4887V25.5903H21.7906V38.791C31.3825 37.8413 38.885 29.75 38.885 19.8922Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoFacebookFooter);
export default __webpack_public_path__ + "static/media/icono_facebook_footer.d71917112d87903b80cf9393b2342034.svg";
export { ForwardRef as ReactComponent };